import { useCallback, useState } from "react";

/**
 * Custom hook for managing modal state.
 *
 * This hook provides a convenient way to manage modal open/close state with consistent
 * behavior across the application. It returns the modal state and callback functions
 * for opening and closing the modal.
 *
 * @returns Object containing modal state and control methods
 * @returns isOpen - Whether the modal is currently open
 * @returns onOpen - Function to open the modal
 * @returns onClose - Function to close the modal
 */
const useModal = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    onOpen,
    onClose,
  };
};

export default useModal;
